import { render, staticRenderFns } from "./CustomBreadcrumbRouter.vue?vue&type=template&id=48390b46&"
import script from "./CustomBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./CustomBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports